import { blue } from '@mui/material/colors';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectTenantInfo } from '@sophocles/features/tenant/slice';

function GenericErrorView({ params }) {
  const tenantInfo = useSelector(selectTenantInfo);

  const { error_id } = params;
  const nerror_id = parseInt(error_id);
  let validError = false;
  if (typeof nerror_id === 'number' && nerror_id % 1 === 0) {
    validError = true;
  }

  return (
    <div
      style={{
        backgroundColor: blue[700],
        color: 'white',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h3>OH NO! Error code: {validError ? error_id : '0000'}</h3>
      <div className="row">
        <div className="offset-lg-3 col-lg-6 col-xs-10 offset-xs-1">
          <p>
            You have encountered an error, if this issue continues, please contact support and be prepared to give them
            the error code above and your email address.
          </p>
        </div>
        <div className="offset-lg-3 col-lg-6 col-xs-10 offset-xs-1">
          <h4>{tenantInfo.organization_name} Support Contact Details</h4>
          <div>Phone: {tenantInfo.contact_phone}</div>
          <div>Email: {tenantInfo.contact_email}</div>
        </div>
        <div className="offset-lg-3 col-lg-6 col-xs-10 offset-xs-1" style={{ marginTop: '10px' }}>
          <p>
            <i className="fas fa-exclamation-triangle" /> No {tenantInfo.organization_name} employee will ever ask you
            for your password. Do not give your password to anyone.
          </p>
        </div>
      </div>
    </div>
  );
}

export default GenericErrorView;
